import mutations from './mutations';
import actions from './actions';
import getters from './getters';

const state = {
  travelArea: {
    notAbroadOption: {},
    abroadOption: {}
  },
  accidentArea:
  {
    notaccidentAbroadOption:{},
    accidentAbroadOption:{}
  },
  indexBanner: [],
  vehicleOption: {
    carOption: {
      carType: [],
      brand: [],
      carStyle: []
    },
    motorOption: {
      carType: [],
      brand: [],
      carStyle: []
    }
  }
}

const dynamicResource = {
  state,
  mutations,
  actions,
  getters
}

export default dynamicResource;